import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Typography, Box, Divider, Grid } from "@mui/material";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from './authConfig';
import Navbar from 'react-bootstrap/Navbar';
import { useIsAuthenticated } from '@azure/msal-react';


import Overview from "./components/Overview";
import DocumentPage from "./components/DocumentPage";
import NavigationBar from "./components/NavigationBar";
import DocumentTable from "./components/DocumentTable";
import { SignInButton } from './components/SignInButton';
import { SignOutButton } from './components/SignOutButton';

function App() {
  const isAuthenticated = useIsAuthenticated();

  return (
    <div className="App">
      <AuthenticatedTemplate>
        <Router>
          <Box sx={{ display: "flex", height: "100%", minHeight: '100vh' }}>
            <NavigationBar />
            <Divider orientation="vertical" flexItem />
            <Box sx={{ width: "80%", p: 2 }}>
              <Routes>
                <Route path="/" element={<Overview />} />
                <Route path="/documents" element={<DocumentTable />} />
                <Route path="/document/:id" element={<DocumentPage />} />
              </Routes>
            </Box>
          </Box>
        </Router>
      </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}

    >
      <Grid container item xs={3} width="60%" justifyContent="center" alignItems="center" >
        <Typography
            variant="h2"
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              mb: 2,
            }}
        >
          Innocence Project
          OpenAI Intake App
        </Typography>
        <Divider sx={{ width: "50%", mb: 3, bgcolor: "primary.main" }} />
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            lineHeight: 1.6,
            color: "text.secondary",
          }}
        >
          The OpenAI Intake App processes all intake letters in Filevine. The app will transcribe the letter to text, 
          summarize the contents of the letter, and perform an analysis on if the letter meets the requirements that 
          the Innocence Project has for taking on a case. If additional info is required, there will be an outline of
          what information is missing in the letter.
        </Typography>
        <div className="collapse navbar-collapse justify-content-end">
            {isAuthenticated ? <SignOutButton /> : <SignInButton />}
        </div>
      </Grid>
    </Grid>
    </UnauthenticatedTemplate>
  </div>
  );
}

export default App;